import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import ContactUs from "./Pages/ContactUs";
import Gallery from "./Pages/Gallery";
import LabSoftware from "./Pages/LabSoftware";
import PharmacySoftware from "./Pages/PharmacySoftware";
import PipelineProducts from "./Pages/PipelineProducts";
import AboutUs from "./Pages/AboutUs";
import VisionMission from "./Pages/VisionMission";
import AboutFounder from "./Pages/AboutFounder";
import FounderMessage from "./Pages/FounderMessage";
import LeaderShip from "./Pages/LeaderShip";
import Operations from "./Pages/Operations";
import NotFound404 from "./Pages/404";
import PathologyLab from "./Pages/PathologyLab";
import PharmacyOutlets from "./Pages/PharmacyOutlets";
import ForDoctor from "./Pages/ForDoctor";
import Endorsements from "./Pages/Endorsements";
import ScrollToTop from "./Components/ScrollToTop";
import ScrollToTopOnRouteChange from "./Components/ScrollToTopOnRouteChange";
import AdvisoryBoard from "./Pages/AdvisoryBoard";
import { SendPostRequest } from "./http";
import { useDispatch } from "react-redux";
import { addBranding } from "./store/reducers/brandingSlice";
import { useEffect } from "react";
import WebBuilder from "./Pages/WebBuilder";
import TeamDetail from "./LabSoftware/TeamDetail";
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
import Dashboard from "./Pages/Dashboard";
import TeamPage from "./Pages/TeamPage";
import TeamDetailPage from "./LabSoftware/TeamDetailPage";
import TeamDetailLayoutSelector from "./Pages/TeamDetailLayoutSelector";
import DemoBooking from "./Pages/DemoBooking";
import Blogs from "./Pages/Blogs";
import BlogDetails from "./Pages/BlogDetails";
import FAQs from "./Pages/FAQs";
import PricingPlans from "./Pages/PricingPlans";
import Portfolio from "./Pages/Portfolio";
import NavbarDemo from "./HomeComponents/NavbarDemo";
import BannerTransition from "./HomeComponents/BannerTransition";
import CompanyOverview from "./Pages/CompanyOverview";

function App() {
  const dispatch = useDispatch();
  const fetchBranding = async () => {
    try {
      const response = await SendPostRequest("branding/info");
      dispatch(addBranding(response?.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchBranding();
  }, []);
  return (
    <>
      <ScrollToTop />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vision-mission" element={<VisionMission />} />
          <Route path="/about-founder" element={<AboutFounder />} />
          <Route path="/founder-message" element={<FounderMessage />} />
          <Route path="/teams" element={<LeaderShip />} />
          {/* Use an explicit path for numeric/UID-based detail to avoid clashing with slug-based detail */}
          <Route path="/team/detail-id/:id" element={<TeamDetail />} />
          <Route path="/team/detail/:slug" element={<TeamDetailPage />} />

          {/* One-page layout selector to preview all Team Detail layouts */}
          <Route path="/team/detail/:slug/test-layouts" element={<TeamDetailLayoutSelector />} />
          
          {/* Team Detail Layout Demo Routes */}
          <Route 
            path="/team/detail/:slug/minimal" 
            element={<TeamDetailPage layoutOptions={{ showImage: false, showActivitiesSkills: false, showProfessionalSkills: false, showNewsletter: false }} />} 
          />
          <Route 
            path="/team/detail/:slug/top-image" 
            element={<TeamDetailPage layoutOptions={{ imagePosition: "top", skillsLayout: "stacked" }} />} 
          />
          <Route 
            path="/team/detail/:slug/right-image" 
            element={<TeamDetailPage layoutOptions={{ imagePosition: "right" }} />} 
          />
          <Route 
            path="/team/detail/:slug/stacked-skills" 
            element={<TeamDetailPage layoutOptions={{ skillsLayout: "stacked" }} />} 
          />
          <Route path="/operations" element={<Operations />} />
          <Route path="/advisory-board" element={<AdvisoryBoard />} />
          <Route path="/pathology-lab" element={<PathologyLab />} />
          <Route path="/pharmacy-outlets" element={<PharmacyOutlets />} />
          <Route path="/for-doctors" element={<ForDoctor />} />

          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/endorsements" element={<Endorsements />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/laris" element={<LabSoftware />} />
          <Route path="/maps" element={<PharmacySoftware />} />
          <Route path="/quest" element={<PipelineProducts />} />
          <Route path="/pipeline-product" element={<Navigate to="/quest" replace />} />
          <Route path="/web-builder" element={<WebBuilder />} />
          <Route path="/*" element={<NotFound404 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/my-account" element={<Dashboard />} />
          {/* New canonical demo request route */}
          <Route path="/request-a-demo" element={<DemoBooking />} />
          {/* Backwards-compatible redirect */}
          <Route path="/book-a-demo" element={<Navigate to="/request-a-demo" replace />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/pricing-plans" element={<PricingPlans />} />
          <Route path="/navbar-demo" element={<NavbarDemo />} />
          <Route path="/banner-transition-demo" element={<BannerTransition />} />

          {/* About: clean canonical URLs */}
          <Route path="/company-overview" element={<CompanyOverview />} />
          <Route path="/leadership-advisors" element={<TeamPage />} />
          
          
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
